import { RouterState } from 'connected-react-router';
import { createSelector } from 'reselect';

import { AppState } from '../../_store/rootReducer';

const selectNode = (state: AppState) => state.router;

export const pathname = createSelector(selectNode, (state: RouterState) => state.location.pathname);
